var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dashboard-widget",
    {
      staticClass: "vendor-transaction-info",
      attrs: { padding: 24, scrollable: "", title: _vm.title }
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: { data: _vm.transactions, size: "medium" },
          on: { "row-click": _vm.onRowClick }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Document Type", prop: "docType" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Document No.", prop: "documentNo" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Date" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDate")(row.dateTrx, true)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Info" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm.isContract(row)
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              effect: "dark",
                              size: "small",
                              type: "success"
                            }
                          },
                          [_vm._v("Exp. " + _vm._s(row.status))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInvoice(row)
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              effect: "dark",
                              size: "small",
                              type: "success"
                            }
                          },
                          [_vm._v(_vm._s(row.status))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isPurchaseOrder(row)
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              effect: "dark",
                              size: "small",
                              type: "success"
                            }
                          },
                          [
                            _vm._v(
                              "Amount " +
                                _vm._s(_vm._f("formatCurrency")(row.status))
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }